import React, { useEffect, useState } from "react";
import { tour } from "../data/tour";
import { IoIosArrowForward } from "react-icons/io";
import dhoorbin from "../../../../../assets/icons/dhoorbin.svg";
import { FaHeart } from "react-icons/fa";
import { IoTime } from "react-icons/io5";
import { FaPeopleGroup } from "react-icons/fa6";
import AllTours from "../../../tours/components/AllTours";
import { getAllFeaturedTours } from "../../../../../api/website/home/homeApi";
import { Link } from "react-router";

const Tour = () => {
  const [Data, setData] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getAllFeaturedTours(setData, setIsLoading);
  }, []);
  return (
    <>
      {Data.length > 0 && !IsLoading ? (
        <>
          {Data.map((item, index) => {
            return (
              <div
                key={index}
                className="bg-white lg:bg-gradient-to-t lg:from-yellow-50 lg:to-green-50 sm:p-0 lg:p-10 rounded-3xl"
              >
                <div>
                  <h2 className="py-4 font-bold text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                    {item.sectionTitle}
                  </h2>
                </div>
                <div>
                  <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {item.selectedTours.map((item, index) => {
                      const Duration =
                        (new Date(item.endDate) - new Date(item.startDate)) /
                        (1000 * 60 * 60 * 24);
                      return (
                        <Link
                          key={index}
                          to={`/tour/details/${item.id}/${item.tourName
                            .toLowerCase()
                            .replace(/ /g, "-")}`}
                        >
                          <div className="">
                            <div className="bg-white shadow-none hover:shadow-lg rounded-md scale-100 hover:scale-105 duration-300 cursor-pointer">
                              <div className="w-full h-auto rounded-md border flex flex-col gap-y-2 p-2">
                                <div className="relative w-full h-50 rounded-md overflow-hidden">
                                  <img
                                    className="w-full h-full object-cover scale-100 hover:scale-105 duration-300"
                                    src={item.images[0].imageLink}
                                    alt=""
                                  />
                                  <div className="absolute top-2 left-2 text-xl text-black bg-[#ecc902d8] px-2 py-0.5 w-auto h-auto rounded-md cursor-pointer text-center">
                                    <p className="text-xs font-semibold">
                                      {new Date(item.startDate).toLocaleString(
                                        "en-US",
                                        {
                                          month: "short",
                                        },
                                      )}
                                    </p>
                                    <p className="text-xs font-semibold">
                                      {new Date(item.startDate).getDate()}
                                    </p>
                                  </div>
                                  {item.isCoupleFriendly && (
                                    <div className="absolute top-2 right-2 text-white bg-[#ff0062ce] px-2 py-0.5 rounded-full cursor-pointer">
                                      <div className="flex items-center justify-start gap-x-2">
                                        <div className="text-[8px]">
                                          <FaHeart />
                                        </div>
                                        <p className="text-[8px] font-semibold">
                                          Couple Friendly
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {item.isDhoorbinChoice === 1 && (
                                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-xs font-semibold bg-[#8bb8fcb4] text-white px-2 py-0.5 rounded-t-lg">
                                      <div className="flex justify-start items-center gap-x-2">
                                        <img
                                          className="w-5 h-5"
                                          src={dhoorbin}
                                          alt=""
                                        />
                                        <p className="text-[10px] font-semibold text-nowrap">
                                          Dhoorbin Choice
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {item.isCustomerChoice === 1 && (
                                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-xs font-semibold bg-[#8bb8fcb4] text-white px-2 py-0.5 rounded-t-lg">
                                      <div className="flex justify-start items-center gap-x-2">
                                        <img
                                          className="w-5 h-5"
                                          src={dhoorbin}
                                          alt=""
                                        />
                                        <p className="text-[10px] font-semibold text-nowrap">
                                          Guest Choice
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {/* {item.discount > 0 && (
                                <div className="absolute top-2 left-2 text-xs font-semibold rounded-full bg-[#153875] text-white px-2 py-0.5">
                                  <p>{item.discount}% off</p>
                                </div>
                              )} */}
                                </div>

                                <div className="flex justify-between items-center">
                                  <div>
                                    <p className="font-bold text-sm text-[#0d2d63]">
                                      {item.tourName}
                                    </p>
                                    <p className="text-[10px] text-black/50">
                                      {item.city}, {item.country}
                                    </p>
                                  </div>
                                  <div className="flex justify-center gap-x-0.5 items-center bg-[#0d2d63] p-0.5 rounded-md">
                                    <div className="text-xs text-white">
                                      <IoTime />
                                    </div>
                                    <p className="text-xs text-white text-nowrap">
                                      {Duration}{" "}
                                      <span className="text-xs text-white">
                                        {Duration > 1 ? "Days" : "Day"}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                                <div className="py-4 relative">
                                  <hr />
                                  <div className="absolute top-1/2 -translate-y-1/2 left-1/2 transform -translate-x-1/2 text-xs bg-[#ffffffb4] text-black/50 px-5 border py-0.5 rounded-md">
                                    <div className="flex justify-start items-center gap-x-2">
                                      <div className="text-[12px] ">
                                        <FaPeopleGroup />
                                      </div>
                                      <p className="text-[12px] text-nowrap">
                                        From {item.minPeople} to{" "}
                                        {item.maxiPeople} persons
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="flex justify-between items-center">
                                  <div className="flex items-center justify-start gap-x-1">
                                    <p className="text-sm font-bold text-black/80">
                                      ৳
                                      {(
                                        item.price -
                                        (item.price * item.discount || 1) / 100
                                      ).toFixed(0)}{" "}
                                    </p>
                                    {item.discount !== 0 && (
                                      <span className="text-xs text-black/40 line-through">
                                        ৳{item.price.toFixed(0)}
                                      </span>
                                    )}
                                  </div>
                                  <div className="flex items-center gap-x-1 border px-1 py-0.5 rounded-md cursor-pointer  scale-100 hover:scale-105 duration-300">
                                    <div>
                                      <p className="text-xs text-black">
                                        Expore Now
                                      </p>
                                    </div>
                                    <div className="text-xs text-black">
                                      <IoIosArrowForward />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className="space-y-5">
          <div className="animate-pulse bg-slate-200 w-36 h-5 rounded-full"></div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {Array.from({ length: 8 }).map((_, index) => {
              return (
                <div
                  key={index}
                  className="animate-pulse bg-slate-200 w-full h-48 rounded-md"
                ></div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Tour;
